import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';

import classnames from 'classnames';
import Button from '@material-ui/core/Button';
import { Formik, Field } from 'formik';
import Grid from '@material-ui/core/Grid';
import GridItem from '../../../shared/GridItem';

import combineStyles from '../../../../helpers/combineStyles';
import LayoutStyles from '../../../../styles/layout';
import ButtonStyles from '../../../../styles/button';
import TypographyStyles from '../../../../styles/typography';
import SpacingStyles from '../../../../styles/helpers/spacing';

import OutlinedSelectChippedInput from '../../../shared/Inputs/OutlinedSelectChipped';
import TextFieldInput from '../../../shared/Inputs/TextField';
import DialogForm from '../../../shared/Modals/DialogForm';
import ProgressButton from '../../../shared/Buttons/ProgressButton';
import RevisionValidation from './Revision.validations';
import { mapOptions } from '../TableMetadata';

export class PromissoryRevokeForm extends Component {
  static propTypes = {
    onClose: PropTypes.func.isRequired,
    onSave: PropTypes.func.isRequired
  };

  _handleOnClose = () => {
    this.props.onClose();
  };

  _handleOnSave = async values => {
    const { onSave } = this.props;
    try {
      await onSave(values);
      return true;
    } catch {
      return false;
    }
  };

  render() {
    const { classes, isSubmitting } = this.props;

    return (
      <Formik
        ref={ref => (this.formik = ref)}
        validationSchema={RevisionValidation}
        enableReinitialize={true}
        validateOnChange={false}
        validateOnBlur={false}
        initialValues={{
          cause: '',
          observations: ''
        }}
        onSubmit={values => {
          this._handleOnSave(values);
        }}
        onReset={(values, actions) => {
          actions.resetForm();
          this._handleOnClose();
        }}
        render={({
          values,
          handleChange,
          handleSubmit,
          handleReset,
          dirty
        }) => (
          <DialogForm
            open={true}
            onClose={handleReset}
            title={
              <div className={classes.titleContainer}>
                <p className={classnames(classes.headline6, classes.title)}>
                  Anular Pagaré
                </p>
              </div>
            }
            footer={
              <Fragment>
                <Button
                  className={classes.button}
                  onClick={handleReset}
                  color={'secondary'}
                  classes={{ label: classes.buttonLabel }}
                >
                  {'Cancelar'}
                </Button>
                <ProgressButton
                  onClick={handleSubmit}
                  className={classes.button}
                  classes={{
                    disabled: classes.buttonDisabled,
                    label: classes.buttonLabel
                  }}
                  color={'secondary'}
                  disabled={!dirty || isSubmitting}
                  isSubmitting={isSubmitting}
                >
                  {'Anular'}
                </ProgressButton>
              </Fragment>
            }
          >
            <Grid container spacing={16}>
              <GridItem xs={12}>
                <Field
                  name="cause"
                  onChange={handleChange}
                  render={({ field, form }) => {
                    return (
                      <OutlinedSelectChippedInput
                        value={values.cause}
                        field={field}
                        form={form}
                        label={'Causa*'}
                        withChip={false}
                        options={mapOptions(this.props.cancelPromissoryCausals)}
                      />
                    );
                  }}
                />
              </GridItem>
              <GridItem xs={12}>
                <Field
                  name="observations"
                  onChange={handleChange}
                  render={({ field, form }) => {
                    return (
                      <TextFieldInput
                        multiline
                        rows={4}
                        name="observations"
                        label="Observaciones*"
                        value={values.observations}
                        onChange={handleChange}
                      />
                    );
                  }}
                />
              </GridItem>
            </Grid>
          </DialogForm>
        )}
      />
    );
  }
}

export default withStyles(
  combineStyles(LayoutStyles, TypographyStyles, ButtonStyles, SpacingStyles)
)(PromissoryRevokeForm);
